module.exports = __webpack_public_path__ + "static/media/slide4.cd2527b7.webp";